import { Component, ElementRef, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, Validators, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { timeout } from 'rxjs/operators';
// import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { ApiService } from '../api.service';
import { CacheService } from '../cache.service';
import { CourseService } from '../course.service';
import { File } from "../file.model"

@Component({
    selector: 'app-file-select',
    templateUrl: './file-select.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FileSelectComponent,
            multi: true,
        },
    ],
    styleUrls: ['./file-select.component.scss'],
})
export class FileSelectComponent implements ControlValueAccessor, OnInit, OnDestroy {
    @Input() id: string;

    form;
    isLoaded = false;
    isLoading = false;
    isLoadingComplete = false;
    display = false;
    files = [];
    total = 0;
    page = 0;
    errorMessage = '';
    queue = false;
    onChange: Function;
    formDataUpdateRegionAlert;
    formDataUpdateBudgetDisciplineAlert;

    constructor(
        private apiService: ApiService,
        private cacheService: CacheService,
        private courseService: CourseService,
        private elementRef: ElementRef,
        private fb: FormBuilder,
    ) {
        // update file select filter if region changes
        this.formDataUpdateRegionAlert = this.courseService.formDataUpdateRegion$.subscribe((value) => {
            // console.log('region updated', value)
            this.form.patchValue({ region: value });
        });

        // update file select filter if budgetDiscipline changes
        this.formDataUpdateBudgetDisciplineAlert = this.courseService.formDataUpdateBudgetDiscipline$.subscribe((value) => {
            // console.log('budgetDiscipline updated', value)
            this.form.patchValue({ budgetDiscipline: value });
        });

        this.prepareForm();
    }

    ngOnInit() {
        if (this.course.region.id){
            this.get();
        }
    }

    ngOnDestroy() {
        // console.log(`clean up component`)
        this.elementRef.nativeElement.remove();
        this.formDataUpdateRegionAlert.unsubscribe();
        this.formDataUpdateBudgetDisciplineAlert.unsubscribe();
    }

    prepareForm(){
        // register form for file select filter
        this.form = this.fb.group({
            region: [this.course.region.id, [Validators.required]],
            budgetDiscipline: [this.course.budgetDiscipline.id, []],
            keyword: [null, []],
        });
        
        // reset files each time filter changes
        this.form.valueChanges.subscribe(() => {
            if (!this.isEditable) return;
            this.reset();
        });
    }

    get() {
        // console.log(`form`,this.form)
        if (this.isLoading || this.isLoadingComplete || this.form.invalid) return;
        this.page += 1;
        this.isLoading = true;
        this.errorMessage = '';
        let filters = this.form.value;
        filters.page = this.page;
        // console.log(`get`,filters)

        this.apiService.getFiles(filters).subscribe(
            (data) => {
                this.total = parseInt(data.total);
                this.files = this.files.concat(
                    data.data.map((file) => new File(file))
                );
                this.isLoading = false;
                this.isLoaded = true;
                this.isLoadingComplete = this.files.length >= data.total;
            },
            (error) => {
                this.errorMessage = error;
                this.isLoading = false;
            }
        );
    }

    add() {
        if ( !this.isLoading && this.region.errors) this.errorMessage = "To proceed please select a Region for this Course"
        this.display = !this.display;
    }

    remove() {
        if ( !confirm(`Are you sure you would like to remove this image?`) ) return;
        this.courseService.formData[this.id] = null;
        this.display = false;
        this.onChange(null);
    }

    select(file) {
        this.display = false;
        this.onChange(file);
    }

    reset(clearQueue = false) {
        // console.log(`FileSelectComponent reset clearQueue:`,clearQueue)
        // if (clearQueue) this.queue = false;

        // // if already waiting w second request don't trigger additional (last filters are all that matter)
        // if (this.queue) return;

        // // if already waiting for a request delay additional request; could look into unsubscribe to stop request (last request is all that matters)
        // if (this.isLoading) {
        //     this.queue = true;
        //     console.log(`wait`)
        //     setTimeout(() => {this.reset(true);}, 500);
        //     return
        // }

        this.files = [];
        this.total = 0;
        this.page = 0;
        this.isLoadingComplete = false;
        // console.log(`reset get`)
        this.get();
    }

    get course() {
        return this.courseService.course;
    }

    get formData() {
        return this.courseService.formData;
    }

    get image() {
        return this.courseService.course.image;
    }

    get courseTaxonomy() {
        return this.cacheService.courseTaxonomy;
    }

    get isEditable() {
        return this.courseService.isEditable;
    }

    get region() {
        return this.form.get('region');
    }

    get budgetDiscipline() {
        return this.form.get('budgetDiscipline');
    }

    get keyword() {
        return this.form.get('keyword');
    }

    get regions() {
        return this.cacheService.regionsScoped;
    }

    get regionDisplayName() {
        let region = this.regions.filter(
            (region) => region.id === this.region.value
        );
        return region.length > 0 ? region[0].displayName : null;
    }

    writeValue(value: null) {}

    registerOnChange(fn: Function) {
        this.onChange = fn;
    }

    registerOnTouched(fn: Function) {}
}